import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string | React.ReactNode;
  confirmText?: string;
  confirmColor?: string;
  confirmHoverColor?: string;
  confirmDisabled?: boolean;
  reverseButtons?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  message = 'よろしいですか？',
  confirmText = '確認',
  confirmColor = '#1B76D2',
  confirmHoverColor = '#1565C0',
  confirmDisabled = false,
  reverseButtons = false,
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '16px'
        }
      }}
    >
      <DialogContent sx={{ pt: 4, pb: 3, px: 3, minWidth: '400px', textAlign: 'center' }}>
        {typeof message === 'string' ? (
          <Typography fontSize="16px">{message}</Typography>
        ) : (
          message
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 2, justifyContent: 'center', flexDirection: reverseButtons ? 'row-reverse' : 'row' }}>
        <Button 
          onClick={onConfirm} 
          variant="contained"
          disabled={confirmDisabled}
          sx={{ 
            backgroundColor: confirmDisabled ? '#CCCCCC' : confirmColor, 
            '&:hover': { backgroundColor: confirmDisabled ? '#CCCCCC' : confirmHoverColor },
            borderRadius: '12px',
            padding: '10px 24px',
            fontSize: '16px',
            minWidth: '120px'
          }}
        >
          {confirmText}
        </Button>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ 
            borderColor: '#E0E0E0', 
            color: '#000000',
            borderRadius: '12px',
            padding: '10px 24px',
            fontSize: '16px',
            minWidth: '120px',
            '&:hover': {
              borderColor: '#BDBDBD',
              backgroundColor: '#F5F5F5'
            }
          }}
        >
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};

